import GeneratedFormulaFunctionsMessages from "@/components/helpNekoLanguage/i18n/generated/FormulaFunctions.json";

export interface HelpFunctionItem {
	code: string;
	description?: string;
	examples?: string[];
}

interface FormulaFunctionMessagesSchema {
	fr: {
		help: {
			description: {
				functions: {
					items: HelpFunctionItem[];
				};
			};
		};
	};
}

const getItems = (messages: FormulaFunctionMessagesSchema): HelpFunctionItem[] => {
	return messages.fr.help.description.functions.items;
};

export const HELP_FORMULA_FUNCTION_ITEMS: HelpFunctionItem[] = getItems(
	GeneratedFormulaFunctionsMessages as FormulaFunctionMessagesSchema
).sort((left, right) => left.code.localeCompare(right.code, "fr"));
